import axios from 'axios';
const updateGameProfile = async (ugrId, profileData) => {
    await axios.put(`${process.env.REPEAT_TOURNAMENT_SERVICE_URL}/lobby-tournament/v1/lobby-tournament/user-game-region/${ugrId}/game-profiles`, profileData);
};
export default updateGameProfile;
